<main>
    <div class="main-wrapper sign-up main-heading">
      <h1 class="heading">Private Routing</h1>
    </div>
    <!--step indicator section starts -->
    <section [attr.aria-label]="currentStep" class="step-section">
      <div class="main-wrapper">
        <app-stepindicator [stepIndicators]="stepIndicators" [sessionName]="sessionName"></app-stepindicator>
      </div>
    </section>
    <router-outlet></router-outlet>
  </main>